import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TimestampPipe } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { MaintanceRoundReport } from 'src/app/models/maintance-round.model';
import { Site } from 'src/app/models/site.model';

@Component({
  selector: 'app-print-maintance-round',
  templateUrl: './print-maintance-round.component.html',
  styleUrls: ['./print-maintance-round.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    TimestampPipe,
  ],
})
export class PrintMaintanceRoundComponent {

  report = input.required<MaintanceRoundReport>();
  site = input.required<Site>();
}
